'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SYSTEM_ID = exports.SYSTEM_ID = 'SYSTEM_ID';